import React from 'react';

import AppRoutes from 'routing/AppRoutes';

const App = () => <AppRoutes />;

export default App;
